import dayjs from 'dayjs';
import { memo, useCallback } from 'react';

import { useWordEditor } from 'com/WordEditor';
import { apiGetWord, apiSetWordStatus } from 'core/api';
import { MenuItem } from 'core/ui/Menu';
import { useMessageModal } from 'core/ui/MessageModal';
import ICONS from 'core/ui/icons';

type TProps = {
  wordUid: string;
  exercise: TExercise;
  goNext: () => void;
  onUpdateWord: (word: TWord) => void;
};

const PostponeButton: React.FC<TProps> = ({
  wordUid,
  exercise,
  goNext,
  onUpdateWord,
}) => {
  const { showError } = useMessageModal();
  const { editWord: openEditor } = useWordEditor();

  const onClick = useCallback(async () => {
    try {
      goNext();

      const word = await apiGetWord(wordUid);
      const status = orDie(word.status[exercise]);
      const upToNow = dayjs.utc().diff(dayjs.utc(status.nextProbeAt), 'minute');
      const shift = DELAY_HOURS * 60 + upToNow;

      status.lastProbeAt = dayjs
        .utc(status.lastProbeAt)
        .add(shift, 'minute')
        .format();
      status.nextProbeAt = dayjs
        .utc(status.nextProbeAt)
        .add(shift, 'minute')
        .format();
      const updWord = await apiSetWordStatus(word.uid, exercise, status);
      onUpdateWord(updWord);
    } catch (err) {
      showError(err);
    }
  }, [wordUid, onUpdateWord, openEditor]);

  return (
    <MenuItem
      label={`Postpone for ${DELAY_HOURS} hours`}
      icon={ICONS.ArrowRight}
      onClick={onClick}
    />
  );
};

const DELAY_HOURS = 6;

export default memo(PostponeButton);
